import { render } from "./ResetPasswordConfirmationModal.vue?vue&type=template&id=74dcd9b4"
import script from "./ResetPasswordConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__